import React, { useEffect, useState } from "react";
import { Select, Form, Segmented, Card, Table, Typography, Button, InputNumber, Popconfirm, Space } from "antd";
import { ProjectService } from "../../../Services/Manage/ProjectService";
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";
import useMessage from "antd/es/message/useMessage";
import ExpenseTable from "./ExpenseTable";
import { UserService } from "../../../Services/Manage/UserService";
import { ExpenseServices } from "../../../Services/Manage/ExpenseServices";
import GeneralExpenseAdd from "./GeneralExpenseAdd";

const { Option, OptGroup } = Select;
const { Text } = Typography;

const AddExpense = ({ onClose, getAllExpense }) => {
    const [projectOption, setProjectOption] = useState([]);
    const [activeType, setActiveType] = useState("Purchase Order");
    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(1);
    const [grandTotal, setGrandTotal] = useState(0);
    const [message, msgContx] = useMessage();
    const [selecteProId, setSelectedProId] = useState(null);

    const [vendorId, setVendorId] = useState(null);
    const [poId, setPoId] = useState("");

    const getAllProjects = async () => {
        try {
            const request = await ProjectService.getAllProject();
         
            setProjectOption(request.data || []);
        } catch (error) {
            console.error(error);
        }
    };


    const groupedProjects = projectOption.reduce((acc, project) => {
        if (!acc[project.qu_no]) {
            acc[project.qu_no] = [];
        }
        acc[project.qu_no].push(project);
        return acc;
    }, {});

    const handleGetDataByQId = (value) => {
        setSelectedProId(value);
    };

    useEffect(() => {
        getAllProjects();
    }, []);


    const handleNewAdd = () => {
        setDataSource([...dataSource, {
            key: count,
            description: "",
            qty: 1,
            unitprice: 0,
            totalprice: 0
        }]);
        setCount(count + 1);
    };

    const handleAdd = (identifier) => {
        const newRow = { key: count, description: "", qty: 1, unitprice: 0, totalprice: 0 };

        const index = dataSource.findIndex((item) => item.id === identifier || item.key === identifier);

        let newData = [...dataSource];
        newData.splice(index + 1, 0, newRow);
        setDataSource(newData);
        setCount(count + 1);
    };

    const handleDelete = async (record) => {
        if (record.id) {
            try {
                console.log(record);

                // const request = await QuotationService.deleteQuotation(record.id);
                // if (request.status) {
                //     const newData = dataSource.filter((item) => item.id !== record.id);
                //     setDataSource(newData);
                //     message.success(request.message);
                // } else {
                //     message.error(request.message);
                // }
            } catch (error) {
                console.error(error);
                message.error("Failed to delete row");
            }
        } else {
            // New row: just remove locally by key
            const newData = dataSource.filter((item) => item.key !== record.key);
            setDataSource(newData);
            message.success("Row deleted");
        }
    };


    const handleChange = (identifier, field, value) => {
        const newData = dataSource.map((item) => {
            if (item.key === identifier || item.id === identifier) {
                const updatedItem = { ...item, [field]: value };
                updatedItem.totalprice = (updatedItem.qty || 0) * (updatedItem.unitprice || 0);
                return updatedItem;
            }
            return item;
        });
        setDataSource(newData);
    };


    const calculateGrandTotal = () => {
        const total = dataSource.reduce((sum, item) => sum + (item.totalprice || 0), 0);
        setGrandTotal(total);
    };

    const handleSave = async () => {


        try {

            if (!selecteProId) {
                message.warning("Please Select Project!")
            }
            const user = await UserService.getOmeUser();
            const formattedData = dataSource.map(({ key, ...rest }) => ({
                ...rest,
                project_id: selecteProId,
                added_by: user.uid,
                type: 'project'
            }));

    

            const request = await ExpenseServices.createExpense(formattedData);
       

            if (request.status) {
                message.success(request.message)
                handleClose();
                getAllExpense();
            } else {
                message.error(request.message)
            }

        } catch (error) {
            console.error(error);

        }

    };

    const handleGeneralSave = async () => {
        try {
            const user = await UserService.getOmeUser();
            const formattedData = dataSource.map(({ key, ...rest }) => ({
                ...rest,
                added_by: user.uid,
                type: 'other',
                vendor_id: vendorId,
               po_id: poId,
            }));

            const request = await ExpenseServices.createExpense(formattedData);
            if (request.status) {
                message.success(request.message)
                handleClose();
                getAllExpense();
            } else {
                message.error(request.message)
            }



        } catch (error) {
            console.error(error);

        }
    }

    const handleClose = async () => {
        onClose();
        setDataSource([]);
    }

    const columns = [
        {
            title: "SI No",
            dataIndex: "key",
            width: '7%',
            align: 'center',
            key: "key",
            render: (_, __, index) => index + 1,
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
            render: (text, record) => (
                <TextArea
                    allowClear
                    rows={2}
                    value={text}
                    onChange={(e) => handleChange(record.id ?? record.key, "description", e.target.value)}

                />
            ),
        },
        {
            title: "Qty",
            dataIndex: "qty",
            width: '12%',
            align: 'center',
            key: "qty",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.id ?? record.key, "qty", value)}
                />
            ),
        },
        {
            title: "Unit Price",
            dataIndex: "unitprice",
            align: 'center',
            width: '12%',
            key: "unitprice",
            render: (text, record) => (
                <InputNumber
                    min={0}
                    value={text}
                    onChange={(value) => handleChange(record.id ?? record.key, "unitprice", value)}
                />
            ),
        },
        {
            title: "Total Price",
            dataIndex: "totalprice",
            align: 'center',
            key: "totalprice",
            render: (text) => <Text>{text}</Text>,
            width: '10%'
        },
        {
            title: "Action",
            key: "action",
            align: 'center',
            width: 120,
            render: (_, record) => (
                <>
                    <Button
                        // disabled={!Eqslected}
                        icon={<PlusOutlined />}
                        type="dashed"
                        size="large"
                        style={{ marginRight: 8 }}
                        onClick={() => handleAdd(record.id ?? record.key)}
                    />
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record)}>
                        <Button icon={<DeleteOutlined />} danger />
                    </Popconfirm>
                </>
            ),
        },
    ];

    return (
        <div>
            {msgContx}
            <div style={{  justifyContent:'center', display:'flex'}}>
            <Segmented
                size="large"
                // block
                options={["Purchase Order", "Project Expense"]}
                value={activeType}
                onChange={(value) => {
                    setDataSource([])
                    setActiveType(value)
                }}
                style={{
                    marginBottom: 24,
                  
                    backgroundColor: "#cfe6fdff",
                    color: "#000000ff",
                    borderRadius: 8,
                    padding: "4px",
                }}
            />

            </div>


            {activeType === "Purchase Order" && (
                <Card>
                    <Form layout="vertical">
                        <GeneralExpenseAdd
                        
                            dataSource={dataSource}
                            setDataSource={setDataSource}
                            handleNewAdd={handleNewAdd}
                            handleAdd={handleAdd}
                            handleDelete={handleDelete}
                            handleChange={handleChange}

                            setVendorId={setVendorId}
                            setPoId={setPoId}
                        />

                        <div style={{
                            marginTop: 50,
                            display: "flex",
                            justifyContent: 'flex-end'
                        }}>
                            <Space>
                                <Button size="large" type="primary"
                                    onClick={handleGeneralSave}
                                >Save</Button>
                                <Button size="large" onClick={handleClose}>Cancle</Button>
                            </Space>
                        </div>
                    </Form>
                </Card>
            )}

            {activeType === "Project Expense" && (
                <Card>
                    <Form layout="vertical">
                        {/* <Form.Item label="Select Project" name="project">
                            <Select
                                showSearch
                                allowClear
                                placeholder="Select approved enquiry"
                                size="large"
                                onChange={handleGetDataByQId}
                                optionFilterProp="children"
                            >
                                {Object.keys(groupedProjects).map((qu_no) => (
                                    <OptGroup key={qu_no} label={`Enquiry No: ${qu_no}`}>
                                        {groupedProjects[qu_no].map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.pro_name} ({item.department_name})
                                            </Option>
                                        ))}
                                    </OptGroup>
                                ))}
                            </Select>
                        </Form.Item> */}

                        <ExpenseTable
                            groupedProjects={groupedProjects}
                            handleGetDataByQId={handleGetDataByQId}
                            dataSource={dataSource}
                            setDataSource={setDataSource}
                            handleNewAdd={handleNewAdd}
                            handleAdd={handleAdd}
                            handleDelete={handleDelete}
                            handleChange={handleChange}
                        />
                    </Form>

                    <div style={{
                        marginTop: 50,
                        display: "flex",
                        justifyContent: 'flex-end'
                    }}>
                        <Space>
                            <Button size="large" type="primary"
                                onClick={handleSave}
                            >Save</Button>
                            <Button size="large" onClick={handleClose}>Cancle</Button>
                        </Space>
                    </div>
                </Card>
            )}

           

        </div>
    );
};

export default AddExpense;
